import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CheckoutListComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/checkout-list';

interface Data {
  checkoutId: number;
  checkoutName: string;
  checkoutMethod: string;
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.html',
  styleUrls: ['./delete-dialog.scss'],
  standalone: false,
})
export class DeleteDialog implements OnInit {
  onDelete = new EventEmitter<number>();
  checkoutId: number;
  checkoutName: string;
  checkoutMethod: string;

  constructor(
    public dialogRef: MatDialogRef<CheckoutListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
  ) {}

  ngOnInit() {
    this.checkoutName = this.data.checkoutName;
    this.checkoutId = this.data.checkoutId;
    this.checkoutMethod = this.data.checkoutMethod;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDeleteCheckout() {
    this.onDelete.emit(this.checkoutId);
    this.dialogRef.close();
  }
}
